<template lang="pug">
div
  //- Title
  .d-flex.justify-space-between
    div.d-flex.align-center
      v-icon.mr-3(size="18") $yzi-file-heart-02
      .text-md.font-semibold {{ $t('diagnosis') }}
    v-hover(v-slot="{ hover }")
      .text-sm.font-semibold.underline.clickable.px-3.py-1.round-lg(:class="[{ 'neutral300':hover }]" @click="onEdit") {{ $t('edit') }}
  v-divider.mt-2.mb-4.neutral500
  //- Content
  ul.mb-4
    template(v-for="item in diagnosis")
      li.text-sm.mb-2 {{ item }}
  template(v-if="!diagnosis.length")
    div.text-center.text-sm.neutral400--text No data available
  .dialogs
    edit-diagnosis-dialog(v-if="showEditDialog" :open.sync="showEditDialog" :parentDiagnosis="diagnosis" :leadPid="leadPid" @updated="$emit('updated', $event)")
</template>

<script>
import EditDiagnosisDialog from '@/components/clinic/dialogs/EditDiagnosisDialog.vue'

export default {
  components: {
    EditDiagnosisDialog,
  },
  props: {
    diagnosis: {
      type: Array,
      default: () => {
        return []
      }
    },
    leadPid: {
      type: String,
      required: true
    },
  },
  data() {
    return {
      showEditDialog: false
    }
  },
  methods: {
    onEdit () {
      this.showEditDialog = true
    }
  },
}
</script>

<style lang="scss" scoped>
</style>